<template>
  <div>
    <v-dialog v-model="dialog" flat persistent width="900px">
      <v-card class="mx-auto py-8" style="overflow: hidden">
        <a href="https://www.firstcryintellitots.com/"><v-btn icon color="error" absolute top
            right><v-icon>mdi-close-circle</v-icon></v-btn></a>
        <v-card-title class="primary--text display-3 font-weight-bold justify-center">Thank You !</v-card-title>
        <v-icon class="d-flex justify-center my-2" size="150" color="pink">mdi-emoticon</v-icon>
        <v-card-subtitle class="d-flex justify-center my-2 title">Your Admission form is submitted successfully.</v-card-subtitle>
      </v-card>
    </v-dialog>
    <section class="">
      <div class="level-item">
        <img style="max-width: 20%;"
          src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/intellitots-logo_updated.png"
        />
      </div>
      <br />
      <v-card
        color="grey lighten-4"
        class="container section page-header section is-main-section"
        flat
        tile
      >
        <v-toolbar>
          <v-app-bar-nav-icon disabled></v-app-bar-nav-icon>
          <v-toolbar-title><b>ADMISSION FORM</b></v-toolbar-title>
          <v-spacer></v-spacer>
          <p small v-if="registrationData.siblingEnquiryID">
            Linked Enquiry: {{ registrationData.siblingEnquiryID }}
          </p>
          <v-spacer></v-spacer>
          <v-btn
            small
            elevation="1"
            color="primary"
            @click="dialogLinkEnquiry = true"
            hover="Link Self enquiry"
          >
            <v-icon left>mdi-plus</v-icon> Link enquiry
          </v-btn>
        </v-toolbar>
      </v-card>
    </section>
    <section class="container section page-header section is-main-section">
      <div v-if="parentdata">
        <form class="container" @submit.prevent="saveRegistration()">
          <div>
            <div class="container">
              <FranchiseeElement
                v-model="parentdata"
                isWritable="false"
                isRequired="true"
              />
            </div>
            <div class="container">
              <StudentElement
                :franchiseeID="franchiseeID"
                :key="studentElementComponentRefresh"
                :isUniformSelection="!isUniformSelectionNotRequired"
                :formType="this.typeForm"
                subType="admission_offon"
                v-model="parentdata"
                isWritable="true"
                isRequired="true"
              />
            </div>
            <div class="container">
              <RegParentElement
                :formType="this.typeForm"
                :isWritable="this.message"
                parentType="father"
                v-model="studentData"
              />
            </div>
            <div class="container">
              <RegParentElement
                :formType="this.typeForm"
                :isWritable="this.message"
                parentType="mother"
                v-model="studentData"
                @setIsCompop="franchiseeCheck"
              />
            </div>
            <div class="container" v-if="showGaurdian">
              <RegParentElement :formType="this.typeForm" :isWritable="this.message" parentType="guardian"
                v-model="studentData" @closeIcon="closeDialog"/>
            </div>

            <div class="container">
              <AddressElement
                v-model="parentdata"
                isWritable="true"
                formType="applicationForm"
              />
            </div>
            <div class="container">
              <OtherElement
                :formType="this.typeForm"
                :isWritable="this.message"
                v-model="parentdata"
              />
            </div>
            <div class="container">
              <SiblingElement
                :formType="this.typeForm"
                :isWritable="this.message"
                v-model="registrationData"
              />
            </div>
            <div class="container">
              <HealthElement
                :formType="this.typeForm"
                :isWritable="this.message"
                v-model="registrationData"
              />
            </div>
            <div class="container" v-if="this.isLoaded === 'true'">
              <RegDocumentElement
                :formType="this.typeForm"
                :isWritable="this.message"
                v-model="registrationData"
                :enquiryID="parentdata.id"
              />
            </div>
            <div class="container">
              <IAgreeCheckbox v-model="registrationData" />
            </div>

            <footer class="column has-text-right">
              <input class="button is-success" type="submit" value="Confirm" />
            </footer>
          </div>
        </form>
      </div>
      <div v-else>
        <div class="level-item">
          <p class="title is-5">Link is not valid....</p>
        </div>
      </div>
    </section>
    <v-card-text
      class="pt-0 pr-1"
      :class="{
        'd-block py-3': $vuetify.breakpoint.xs,
        'd-flex align-center': $vuetify.breakpoint.smAndUp
      }"
    >
      <v-dialog
        max-width="1300px"
        v-model="dialogLinkEnquiry"
        persistent
        :class="{ 'is-active': enableEnquiryModal }"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Search Enquiry</span>
          </v-card-title>
          <v-btn
            class="mt-8"
            color="error"
            elevation="1"
            small
            fab
            absolute
            top
            right
            @click=";(dialogLinkEnquiry = false), resetEnquiry()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-text>
            <v-container>
              <form @submit.prevent="studEnquiry">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-autocomplete
                      outlined
                      dense
                      v-model="findEnquiry.searchType"
                      label="Search Type"
                      :items="findType"
                      item-text="text"
                      item-value="value"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <b-autocomplete
                      v-model="findEnquiry.searchKey"
                      v-if="findEnquiry.searchType === 'studentmobile'"
                      maxlength="10"
                      placeholder="Enter Mobile Number"
                      @input="studEnquiry($event)"
                      v-on:select="selectEvent()"
                      :data="findDataArr"
                    >
                    </b-autocomplete>
                    <b-autocomplete
                      v-model="findEnquiry.searchKey"
                      v-if="findEnquiry.searchType === 'studentname'"
                      placeholder="Enter student name"
                      @input="studEnquiry()"
                      v-on:select="selectEvent()"
                      :data="findDataArr"
                    >
                    </b-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-btn
                      elevation="1"
                      color="success"
                      @click="passed()"
                      type="submit"
                    >
                      <v-icon left>mdi-magnify</v-icon> Search
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-data-table
                    v-if="enquiryTableData.length > 0"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 20, 40]
                    }"
                    :items-per-page="40"
                    item-key="srno"
                    :headers="stdEnqModalHeaders"
                    :items="enquiryTableData"
                  >
                    <template v-slot:item.srno="{ item }">
                      {{ item.srno }}
                    </template>
                    <template v-slot:item.enquiryCode="{ item }">
                      {{ item.enquiryCode || '-' }} /
                      {{
                        item.franchiseeName ||
                        item.franchisee.companyName ||
                        '-'
                      }}
                    </template>
                    <template v-slot:item.createdAt="{ item }">{{
                      item.dateOfEnquiry
                    }}</template>
                    <template v-slot:item.studentFirstName="{ item }">
                      <span>{{
                        item.studentFirstName + '' + item.studentLastName || '-'
                      }}</span>
                    </template>
                    <template v-slot:item.studentClassName="{ item }">
                      <span>{{
                        item.studentClass ? item.studentClass.name : '-'
                      }}</span> </template
                    ><template v-slot:item.studentClassCategory="{ item }">
                      <span>{{
                        item.studentClass ? item.studentClass.category : '-'
                      }}</span>
                    </template>
                    <template v-slot:item.fatherName="{ item }">
                      <span>{{ item.fatherName || '-' }}</span>
                    </template>
                    <template v-slot:item.fatherMobile="{ item }">
                      <span>{{ item.fatherMobile || '-' }}</span>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        class="px-2 ml-1 ma-1"
                        color="primary"
                        min-width="0"
                        small
                        @click="getSelfEnquiry(item.enquiryCode)"
                        type="submit"
                      >
                        link as self enquiry
                      </v-btn>
                    </template>
                    <template v-slot:no-data>
                      <v-card-subtitle class="d-flex justify-center"
                        >No Data Available
                      </v-card-subtitle>
                    </template>
                  </v-data-table>
                </v-row>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'
import moment from 'moment'
import FranchiseeElement from '@/components/Forms/Elements/FranchiseeElement'
import StudentElement from '@/components/Forms/Elements/StudentElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'
import HealthElement from '@/components/Forms/Elements/HealthElement'
import RegDocumentElement from '@/components/Forms/Elements/RegDocs'
import SiblingElement from '@/components/Forms/Elements/SiblingElement'
import IAgreeCheckbox from '@/components/Forms/Elements/IAgreeCheckbox'
// import ParticularList from '../Fees/payment/particularList'
import OtherElement from '@/components/Forms/Elements/OtherElement'
import RegParentElement from '@/components/Forms/Elements/RegParentElement'
// import uniformApplication from '@/components/StudentUniforms/uniformApplication'

export default {
  name: 'applicationFormOffline',
  props: ['refID'],
  components: {
    FranchiseeElement,
    StudentElement,
    RegParentElement,
    AddressElement,
    // ParticularList,
    HealthElement,
    RegDocumentElement,
    SiblingElement,
    IAgreeCheckbox,
    OtherElement
  },
  data: function () {
    return {
      franchiseeID: '',
      checkboxGroup: ['SMS'],
      parentdata: {},
      enableSearchModal: false,
      findEnquiry: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      findType: [
        { text: 'Mobile Number', value: 'studentmobile' },
        { text: 'Student Name', value: 'studentname' }
        // { text: 'Enquiry Code', value: 'enquiryCode' }
      ],
      stdEnqModalHeaders: [
        { text: 'Sr No', value: 'srno', sortable: true },
        { text: 'Enquiry Code', value: 'enquiryCode', sortable: true },
        { text: 'Enquiry Date', value: 'createdAt', sortable: true },
        { text: 'Student Name', value: 'studentFirstName', sortable: true },
        { text: 'Opting Class', value: 'studentClassName', sortable: true },
        {
          text: 'Class category',
          value: 'studentClassCategory',
          sortable: true
        },
        { text: 'Parent Name', value: 'fatherName', sortable: true },
        { text: 'Parent Mobile Number', value: 'fatherMobile', sortable: true },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      enableEnquiryModal: false,
      findData: [],
      findDataArr: [],
      dialogLinkEnquiry: false,
      enquiryTableData: [],
      previousGenderSelected: '',
      studentData: {},
      registrationData: {},
      enableModal: false,
      enableChangeRequestModal: false,
      showSection: '',
      franchiseeName: '',
      academicYr: '',
      className: '',
      query: '',
      enquiryCode: '',
      typeForm: 'edit_registration',
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      payModal: false,
      formType: '',
      message: 'true',
      isLoaded: 'false',
      dialog: false,
      uniforms: {},
      apparelTypes: [],
      studentElementComponentRefresh: 0,
      isUniformSelectionNotRequired: true,
      showGaurdian: false
    }
  },
  async created () {
    await this.onstart()
    await this.writable()
  },
  methods: {
    writable: async function () {
      if (this.isLoaded === 'true') {
        this.message = 'false'
        this.typeForm = 'edit_registration'
      }
    },
    franchiseeCheck: function (isCompoFlag) {
      this.showGaurdian = isCompoFlag
    },
    closeDialog: function (isCompoFlag) {
      this.showGaurdian = isCompoFlag
    },
    onstart: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/getReferenceDetails/${this.refID}`
        )
        let getRefDetails = data
        if (!_.isEmpty(getRefDetails)) {
          this.parentdata = data
          this.franchiseeID = data.franchiseeID
          if (!_.isEmpty(this.parentdata.enquiryRegistrations)) {
            let registrationData = this.parentdata.enquiryRegistrations
            this.registrationData = registrationData[0]
            this.isRegistered = true
          }
          if (this.parentdata.enquiryCode) {
          }
          this.studentData = this.parentdata
          if (_.isEmpty(this.studentData.fatherEmailID)) {
            this.studentData.fatherEmailID = this.studentData.motherEmailID
          }
          if (this.studentData.guardianName) {
            this.showGaurdian = true
          }
          if (this.studentData.transportManagedByCenter) {
            this.studentData.transportMode = 'center'
          } else if (this.studentData.transportManagedByVendor) {
            this.studentData.transportMode = 'vendor'
          } else {
            this.studentData.transportMode = 'self'
          }
          this.studentData.address = this.parentdata.address1
          this.parentdata.address = this.parentdata.address1
          this.parentdata.studentFirstName = this.parentdata.studentFirstName
          this.parentdata.studentLastName = this.parentdata.studentLastName
          this.parentdata.studentMiddleName = this.parentdata.studentMiddleName
          this.parentdata.gender = _.startCase(
            _.toLower(this.parentdata.gender)
          )
          this.previousGenderSelected = this.parentdata.gender
          this.parentdata.exposureToEnglishLanguage = !_.isEmpty(
            this.registrationData.exposureToEnglishLanguage
          )
            ? this.registrationData.exposureToEnglishLanguage
            : ''
          this.parentdata.motherTongue = !_.isEmpty(
            this.registrationData.motherTongue
          )
            ? this.registrationData.motherTongue
            : ''
          this.parentdata.identificationMarks = !_.isEmpty(
            this.registrationData.identificationMarks
          )
            ? this.registrationData.identificationMarks
            : ''
          this.parentdata.emergencyContactDetails = !_.isEmpty(
            this.registrationData.emergencyContactDetails
          )
            ? this.registrationData.emergencyContactDetails
            : ''
          this.parentdata.fatherDesignation = !_.isEmpty(
            this.registrationData.fatherDesignation
          )
            ? this.registrationData.fatherDesignation
            : ''
          this.parentdata.fatherQualification = !_.isEmpty(
            this.registrationData.fatherQualification
          )
            ? this.registrationData.fatherQualification
            : ''
          this.parentdata.fatherOrganisation = !_.isEmpty(
            this.registrationData.fatherOrganisation
          )
            ? this.registrationData.fatherOrganisation
            : ''
          this.parentdata.fatherOfficePhoneNo = !_.isEmpty(
            this.registrationData.fatherOfficePhoneNo
          )
            ? this.registrationData.fatherOfficePhoneNo
            : ''
          this.parentdata.fatherOfficeAddress =
            !_.isEmpty(this.registrationData.fatherOfficeAddress) &&
            this.registrationData.fatherOfficeAddress !== 'undefined'
              ? this.registrationData.fatherOfficeAddress
              : ''
          this.parentdata.motherDesignation =
            !_.isEmpty(this.registrationData.motherDesignation) &&
            this.registrationData.motherDesignation !== 'undefined'
              ? this.registrationData.motherDesignation
              : ''
          this.parentdata.motherQualification =
            !_.isEmpty(this.registrationData.motherQualification) &&
            this.registrationData.motherQualification !== 'undefined'
              ? this.registrationData.motherQualification
              : ''
          this.parentdata.motherOrganisation =
            !_.isEmpty(this.registrationData.motherOrganisation) &&
            this.registrationData.motherOrganisation !== 'undefined'
              ? this.registrationData.motherOrganisation
              : ''
          this.parentdata.motherOfficePhoneNo =
            !_.isEmpty(this.registrationData.motherOfficePhoneNo) &&
            this.registrationData.motherOfficePhoneNo !== 'undefined'
              ? this.registrationData.motherOfficePhoneNo
              : ''
          this.parentdata.motherOfficeAddress =
            !_.isEmpty(this.registrationData.motherOfficeAddress) &&
            this.registrationData.motherOfficeAddress !== 'undefined'
              ? this.registrationData.motherOfficeAddress
              : ''
          this.parentdata.emergencyContactDetails =
            !_.isEmpty(this.registrationData.emergencyContactDetails) &&
            this.registrationData.emergencyContactDetails !== 'undefined'
              ? this.registrationData.emergencyContactDetails
              : ''
          this.parentdata.siblingName =
            !_.isEmpty(this.registrationData.siblingName) &&
            this.registrationData.siblingName !== 'undefined' &&
            this.registrationData.siblingName !== null
              ? this.registrationData.siblingName
              : ''
          this.parentdata.siblingAge =
            !_.isEmpty(this.registrationData.siblingAge) &&
            this.registrationData.siblingAge !== 'undefined'
              ? this.registrationData.siblingAge
              : ''
          this.parentdata.siblingClass =
            !_.isEmpty(this.registrationData.siblingClass) &&
            this.registrationData.siblingClass !== 'undefined'
              ? this.registrationData.siblingClass
              : ''
          this.parentdata.siblingSchool =
            !_.isEmpty(this.registrationData.siblingSchool) &&
            this.registrationData.siblingSchool !== 'undefined'
              ? this.registrationData.siblingSchool
              : ''
          this.parentdata.referralsChildName =
            !_.isEmpty(this.registrationData.referralsChildName) &&
            this.registrationData.referralsChildName !== 'undefined'
              ? this.registrationData.referralsChildName
              : ''
          this.parentdata.referralsChildAge =
            !_.isEmpty(this.registrationData.referralsChildAge) &&
            this.registrationData.referralsChildAge !== 'undefined'
              ? this.registrationData.referralsChildAge
              : ''
          this.parentdata.referralsFatherMotherName =
            !_.isEmpty(this.registrationData.referralsFatherMotherName) &&
            this.registrationData.referralsFatherMotherName !== 'undefined'
              ? this.registrationData.referralsFatherMotherName
              : ''
          this.parentdata.referralsFatherMotherMobileNo =
            !_.isEmpty(this.registrationData.referralsFatherMotherMobileNo) &&
            this.registrationData.referralsFatherMotherMobileNo !== 'undefined'
              ? this.registrationData.referralsFatherMotherMobileNo
              : ''
          this.parentdata.referralsRelation =
            !_.isEmpty(this.registrationData.referralsRelation) &&
            this.registrationData.referralsRelation !== 'undefined'
              ? this.registrationData.referralsRelation
              : ''
          this.parentdata.childsReactionForNewSituation =
            !_.isEmpty(this.registrationData.childsReactionForNewSituation) &&
            this.registrationData.childsReactionForNewSituation !== 'undefined'
              ? this.registrationData.childsReactionForNewSituation
              : ''
          this.parentdata.placeOfBirth =
            !_.isEmpty(this.registrationData.placeOfBirth) &&
            this.registrationData.placeOfBirth !== 'undefined'
              ? this.registrationData.placeOfBirth
              : ''
          this.parentdata.siblingOtherSchool =
            !_.isEmpty(this.registrationData.siblingOtherSchool) &&
            this.registrationData.siblingOtherSchool !== 'undefined'
              ? this.registrationData.siblingOtherSchool
              : ''
          this.registrationData.franchiseeID = this.parentdata.franchisee.id
          this.registrationData.dateForSeriousAccidentsOrIllnessOrOperations =
            this.isDate(
              this.registrationData.dateForSeriousAccidentsOrIllnessOrOperations
            )
          this.registrationData.chikenpoxVaricellaVaccineDate = this.isDate(
            this.registrationData.chikenpoxVaricellaVaccineDate
          )
          this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate =
            this.isDate(
              this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate
            )
          this.registrationData.hepatitisAHepAVaccineDate = this.isDate(
            this.registrationData.hepatitisAHepAVaccineDate
          )
          this.registrationData.hepatitisBHepBVaccineDate = this.isDate(
            this.registrationData.hepatitisBHepBVaccineDate
          )
          this.registrationData.tetanusDTapDate = this.isDate(
            this.registrationData.tetanusDTapDate
          )
          this.registrationData.diptheriaDTapVaccineDate = this.isDate(
            this.registrationData.diptheriaDTapVaccineDate
          )
          this.parentdata.dateOfBirth = this.isDate(this.parentdata.dateOfBirth)
          this.parentdata.placeOfBirth =
            !_.isEmpty(this.registrationData.placeOfBirth) &&
            this.registrationData.placeOfBirth !== 'undefined'
              ? this.registrationData.placeOfBirth
              : ''
          this.registrationData.enquiryID = this.enquiryID
          this.registrationData.enquiryCode = this.parentdata.enquiryCode
          this.parentdata.getAcademicYear =
            this.parentdata.franchiseeAcademicYear.academicYear
          this.parentdata.getClassName = this.parentdata.studentClass.name
          this.parentdata.franchiseeName = !_.isEmpty(
            this.parentdata.franchisee
          )
            ? this.parentdata.franchisee.companyName
            : ''
          //   this.parentdata.motherName = !_.isEmpty(this.registrationData.motherName) && (this.registrationData.motherName !== 'undefined') ? this.registrationData.motherName : ''
          //   this.parentdata.motherOccupation = !_.isEmpty(this.registrationData.motherOccupation) ? this.registrationData.motherOccupation : ''
          this.typeForm = 'edit_registration'
          this.isLoaded = 'true'
          this.isUniformSelectionNotRequired = _.isEqual(this.parentdata.studentClass.category, constants.classCategory.BRIDGE_COURSE) || _.isEqual(
            this.parentdata.studentClass.category,
            constants.classCategory.PARENT_TODDLER
          )
          this.studentElementComponentRefresh++
        } else {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Invalid Link..',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        const stateresponse = await http.get(`${constants.API_URL}/api/states`)
        this.states = stateresponse.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    getSelfEnquiry: async function (enquiryCode) {
      this.loadingComponent = this.$buefy.loading.open()
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/registration-details/${enquiryCode}`
        )
        if (!_.isEmpty(data)) {
          this.registrationData.siblingEnquiryID = data.enquiryCode
          let registrationData = data.enquiryRegistrations.length
            ? data.enquiryRegistrations[0]
            : {}
          this.studentData.address = data.address1
          this.parentdata.address = data.address1
          console.log(this.parentdata.address, data.address1)
          this.parentdata.studentFirstName = data.studentFirstName
          this.parentdata.studentLastName = data.studentLastName
          this.parentdata.studentMiddleName = data.studentMiddleName
          this.previousGenderSelected = this.parentdata.gender
          this.parentdata.gender = _.startCase(_.toLower(data.gender))
          this.parentdata.pointOfContact = data.pointOfContact
          this.parentdata.exposureToEnglishLanguage = !_.isEmpty(
            registrationData
          )
            ? registrationData.exposureToEnglishLanguage
            : ''
          this.parentdata.motherTongue = !_.isEmpty(registrationData)
            ? registrationData.motherTongue
            : ''
          this.parentdata.identificationMarks = !_.isEmpty(registrationData)
            ? registrationData.identificationMarks
            : ''
          this.parentdata.emergencyContactDetails = !_.isEmpty(registrationData)
            ? registrationData.emergencyContactDetails
            : ''
          this.parentdata.fatherDesignation = !_.isEmpty(registrationData)
            ? registrationData.fatherDesignation
            : ''
          this.parentdata.fatherQualification = !_.isEmpty(registrationData)
            ? registrationData.fatherQualification
            : ''
          this.parentdata.fatherOrganisation = !_.isEmpty(registrationData)
            ? registrationData.fatherOrganisation
            : ''
          this.parentdata.fatherOfficePhoneNo = !_.isEmpty(registrationData)
            ? registrationData.fatherOfficePhoneNo
            : ''
          this.parentdata.fatherOfficeAddress =
            !_.isEmpty(registrationData) &&
            registrationData.fatherOfficeAddress !== 'undefined'
              ? registrationData.fatherOfficeAddress
              : ''
          this.parentdata.motherDesignation =
            !_.isEmpty(registrationData) &&
            registrationData.motherDesignation !== 'undefined'
              ? registrationData.motherDesignation
              : ''
          this.parentdata.motherQualification =
            !_.isEmpty(registrationData) &&
            registrationData.motherQualification !== 'undefined'
              ? registrationData.motherQualification
              : ''
          this.parentdata.motherOrganisation =
            !_.isEmpty(registrationData) &&
            registrationData.motherOrganisation !== 'undefined'
              ? registrationData.motherOrganisation
              : ''
          this.parentdata.motherOfficePhoneNo =
            !_.isEmpty(registrationData) &&
            registrationData.motherOfficePhoneNo !== 'undefined'
              ? registrationData.motherOfficePhoneNo
              : ''
          this.parentdata.motherOfficeAddress =
            !_.isEmpty(registrationData) &&
            registrationData.motherOfficeAddress !== 'undefined'
              ? registrationData.motherOfficeAddress
              : ''
          this.parentdata.emergencyContactDetails =
            !_.isEmpty(registrationData) &&
            registrationData.emergencyContactDetails !== 'undefined'
              ? registrationData.emergencyContactDetails
              : ''
          this.parentdata.siblingName =
            !_.isEmpty(registrationData) &&
            registrationData.siblingName !== 'undefined' &&
            registrationData.siblingName !== null
              ? registrationData.siblingName
              : ''
          this.parentdata.siblingAge =
            !_.isEmpty(registrationData) &&
            registrationData.siblingAge !== 'undefined'
              ? registrationData.siblingAge
              : ''
          this.parentdata.siblingClass =
            !_.isEmpty(registrationData) &&
            registrationData.siblingClass !== 'undefined'
              ? registrationData.siblingClass
              : ''
          this.parentdata.siblingSchool =
            !_.isEmpty(registrationData) &&
            registrationData.siblingSchool !== 'undefined'
              ? registrationData.siblingSchool
              : ''
          this.parentdata.referralsChildName =
            !_.isEmpty(registrationData) &&
            registrationData.referralsChildName !== 'undefined'
              ? registrationData.referralsChildName
              : ''
          this.parentdata.referralsChildAge =
            !_.isEmpty(registrationData) &&
            registrationData.referralsChildAge !== 'undefined'
              ? registrationData.referralsChildAge
              : ''
          this.parentdata.referralsFatherMotherName =
            !_.isEmpty(registrationData) &&
            registrationData.referralsFatherMotherName !== 'undefined'
              ? registrationData.referralsFatherMotherName
              : ''
          this.parentdata.referralsFatherMotherMobileNo =
            !_.isEmpty(registrationData) &&
            registrationData.referralsFatherMotherMobileNo !== 'undefined'
              ? registrationData.referralsFatherMotherMobileNo
              : ''
          this.parentdata.referralsRelation = !_.isEmpty(registrationData)
            ? registrationData.referralsRelation
            : ''
          this.parentdata.childsReactionForNewSituation =
            !_.isEmpty(registrationData) &&
            registrationData.childsReactionForNewSituation !== 'undefined'
              ? this.registrationData.childsReactionForNewSituation
              : ''
          this.parentdata.placeOfBirth =
            !_.isEmpty(registrationData) &&
            registrationData.placeOfBirth !== 'undefined'
              ? registrationData.placeOfBirth
              : ''
          this.parentdata.siblingOtherSchool =
            !_.isEmpty(this.registrationData) &&
            registrationData.siblingOtherSchool !== 'undefined'
              ? registrationData.siblingOtherSchool
              : ''
          this.registrationData.dateForSeriousAccidentsOrIllnessOrOperations =
            this.isDate(
              registrationData.dateForSeriousAccidentsOrIllnessOrOperations
            )
          this.registrationData.chikenpoxVaricellaVaccineDate = this.isDate(
            registrationData.chikenpoxVaricellaVaccineDate
          )
          this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate =
            this.isDate(
              registrationData.haemophilusInfluenzaTypeBHiBVaccineDate
            )
          this.registrationData.hepatitisAHepAVaccineDate = this.isDate(
            registrationData.hepatitisAHepAVaccineDate
          )
          this.registrationData.hepatitisBHepBVaccineDate = this.isDate(
            registrationData.hepatitisBHepBVaccineDate
          )
          this.registrationData.tetanusDTapDate = this.isDate(
            registrationData.tetanusDTapDate
          )
          this.registrationData.diptheriaDTapVaccineDate = this.isDate(
            registrationData.diptheriaDTapVaccineDate
          )
          this.parentdata.dateOfBirth = this.isDate(data.dateOfBirth)
          this.parentdata.placeOfBirth =
            !_.isEmpty(registrationData) &&
            registrationData.placeOfBirth !== 'undefined'
              ? registrationData.placeOfBirth
              : ''
        } else {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Invalid Link..',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
        this.resetEnquiry()
      }
    },
    isDate: function (date) {
      if (!date) {
        return ''
      } else return moment(date).format('YYYY-MM-DD')
    },
    openModal: async function () {
      this.enableModal = true
    },
    toggleEnquiryModal: function () {
      this.enableEnquiryModal = !this.enableEnquiryModal
    },
    studEnquiry: async function (e) {
      // e.target.value = e.target.value.replace(/[^0-9]+/g, '')
      try {
        if (
          typeof e === 'string' &&
          isNaN(e) &&
          this.findEnquiry.searchType === 'studentmobile'
        ) {
          return this.$dialog.error({
            text: 'Only Use Numbers',
            title: 'Error'
          })
        }
        if (
          (this.findEnquiry.searchType === 'studentname' &&
            this.findEnquiry.searchKey.length < 3) ||
          (this.findEnquiry.searchType === 'studentmobile' &&
            this.findEnquiry.searchKey.length < 3)
        ) {
          return
        }
        const { data } = await http.post(
          `${constants.API_URL}/api/search-enquiry/`,
          {
            franchiseeID: this.parentdata.franchisee.id,
            academicYearID: this.studentData.academicYearID,
            searchType: this.findEnquiry.searchType,
            searchKey: this.findEnquiry.searchKey
          }
        )
        this.findData = data
        let nameArray = []
        if (this.findEnquiry.searchType === 'studentmobile') {
          nameArray = this.findData.map((i) => i.fatherMobile)
        } else {
          nameArray = this.findData.map((i) => i.studentFirstName)
        }
        this.findDataArr = await this.FilterResultData(nameArray)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    resetEnquiry: function () {
      this.findEnquiry = {
        academicYearID: this.studentData.academicYearID,
        searchType: 'studentmobile',
        searchKey: ''
      }
      this.dialogLinkEnquiry = false
      this.enquiryTableData = ''
      this.toggleEnquiryModal()
    },
    getResults: async function () {
      try {
        if (!this.findEnquiry.searchKey.length) {
          return
        }
        const { data } = await http.post(
          `${constants.API_URL}/api/search-enquiry/`,
          {
            franchiseeID: this.parentdata.franchisee.id,
            academicYearID: this.studentData.academicYearID,
            searchType: this.findEnquiry.searchType,
            searchKey: this.findEnquiry.searchKey
          }
        )
        this.enquiryTableData = data
        this.enquiryTableData = this.enquiryTableData.filter(
          (obj) =>
            obj.enquiryCode !== this.parentdata.enquiryCode ||
            obj.enquiryCode !== this.studentData.enquiryCode
        )
        this.downEnquiry = data.rows
        console.log(' this.enquiryTableData', this.enquiryTableData)
        this.enquiryTableData.filter((item, index) => {
          item.srno = index + 1
          let spancoName = item.spancoStatus
            ? item.spancoStatus
            : this.spancoDefaultStatus
          let spancoStg = item.enquiryStage
            ? item.enquiryStage.name
            : this.spancoDefaultStage
          item.spancoStage = spancoName + ' - ' + spancoStg
          item.dateOfEnquiry = moment(item.dateOfEnquiry).format(
            'MMMM Do YYYY, HH:mm a'
          )
          item.createdAt = moment(item.createdAt).format(
            'MMMM Do YYYY, HH:mm a'
          )
          item.followUpDate = moment(item.followUpDate).format(
            'MMMM Do YYYY, HH:mm a'
          )
        })
        this.total = this.enquiryTableData.length
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry data : ', errorMessage)
      }
    },
    searchStud: function () {
      if (this.findEnquiry.searchType === 'studentmobile') {
        Utils.isNumber()
      }
    },
    passed: function () {
      if (_.isEmpty(this.findDataArr)) {
        this.$dialog.notify.info(
          'Record You are Searching for is not found. please create new entry',
          {
            color: 'warning',
            position: 'top',
            timeout: 5000
          }
        )
        if (this.findEnquiry.searchType === 'studentmobile') {
          this.$router.push({
            name: 'enquiryForm',
            params: {
              fatherMobiles: this.findEnquiry.searchKey,
              franchisee: this.franchisee.id
            }
          })
        } else {
          this.$router.push({
            name: 'enquiryForm',
            params: {
              studentName: this.findEnquiry.searchKey,
              franchisee: this.franchisee.id
            }
          })
        }
      } else if (
        this.findEnquiry.searchKey === '' &&
        this.findEnquiry.searchType === 'studentmobile'
      ) {
        this.$dialog.message.info('Enter Mobile Number', {
          position: 'top',
          timeout: 5000
        })
      } else if (
        this.findEnquiry.searchKey === '' &&
        this.findEnquiry.searchType === 'studentname'
      ) {
        this.$buefy.toast.open({
          message: 'Enter Student Name',
          queue: false,
          type: 'is-danger'
        })
        this.$dialog.message.info('Enter Student Name', {
          position: 'top',
          timeout: 5000
        })
      } else if (this.findData.length > 0) {
        this.getResults()
      } else if (
        (this.findEnquiry.searchType === 'studentname' &&
          this.findEnquiry.searchKey.length < 5) ||
        (this.findEnquiry.searchType === 'studentmobile' &&
          this.findEnquiry.searchKey.length < 10)
      ) {
        // this.alertFunction()
      } else {
        if (this.findEnquiry.searchType === 'studentmobile') {
          this.$router.push({
            name: 'enquiryForm',
            params: {
              fatherMobiles: this.findEnquiry.searchKey,
              franchisee: this.franchisee.id
            }
          })
        } else {
          this.$router.push({
            name: 'enquiryForm',
            params: {
              studentName: this.findEnquiry.searchKey,
              franchisee: this.franchisee.id
            }
          })
        }
      }
    },
    alertFunction: function () {
      if (this.findEnquiry.searchType === 'studentmobile') {
        this.$dialog.message.warning('Enter 10 digit Mobile Number', {
          position: 'top',
          timeout: 5000
        })
      }
    },
    FilterResultData: async function (resObj) {
      let result = resObj.filter((option) => {
        console.log(option, this.findEnquiry.searchKey)
        return option.indexOf(this.findEnquiry.searchKey) >= 0
      })
      return result
    },
    selectEvent: function () {
      if (this.findData.length > 0) {
        this.getResults()
      }
    },
    saveRegistration: async function () {
      try {
        if (
          this.studentData.isTransportBypass === true &&
          this.studentData.transportMode === 'center'
        ) {
          this.$buefy.toast.open({
            message:
              'This transport option requires completing the Centre’s transport fee payment before switching. Please complete the payment to proceed.',
            type: 'is-danger',
            duration: 8000
          })
          return
        }
        if (!this.isUniformSelectionNotRequired) {
          // Uniform Size Validation
          let uniforms = this.parentdata?.uniforms || []
          for (let key in uniforms) {
            for (let obj of uniforms[key]) {
              if (
                !obj.selectedProductDetails &&
                !this.isUniformSelectionNotRequired
              ) {
                if (this.previousGenderSelected !== this.parentdata.gender) {
                  return this.$buefy.toast.open({
                    message:
                      'Please reselect the uniform sizes as gender is updated.',
                    type: 'is-danger',
                    duration: 4000
                  })
                } else {
                  return this.$buefy.toast.open({
                    message: 'Please select all uniform sizes.',
                    type: 'is-danger',
                    duration: 4000
                  })
                }
              }
            }
          }
          if (uniforms.length === 0 && !this.isUniformSelectionNotRequired) {
            return this.$buefy.toast.open({
              message: 'Something went wrong with the unform selection.',
              type: 'is-danger',
              duration: 4000
            })
          }
        }

        if (this.parentdata.pointOfContact === 'MOTHER') {
          if (
            _.isEmpty(this.studentData.motherName) ||
            _.isEmpty(this.studentData.motherEmailID) ||
            _.isEmpty(this.studentData.motherMobile)
          ) {
            this.loadingComponent.close()
            this.lock = false
            this.hasClicked = false
            return this.$buefy.dialog.alert({
              message:
                'Please Fill Mother Details as you have selected Mother as Point of contact',
              type: 'is-danger',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',
              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
        if (this.studentData.motherName) {
          if (_.isEmpty(this.studentData.motherEmailID) || this.studentData.motherMobile === null) {
            this.errMsg('Please fill all mandetory mother details.')
            return false
          }
        } else if (this.studentData.motherMobile) {
          if (_.isEmpty(this.studentData.motherName) || this.studentData.motherEmailID === null) {
            this.errMsg('Please fill all mandetory mother details.')
            return false
          }
        }
        if (this.studentData.motherName === null) {
          this.studentData.guardianName = ''
          this.studentData.guardianMobile = ''
          this.studentData.guardianEmailID = ''
        }
        if (!this.parentdata.dateOfBirth) {
          return this.$dialog.error({
            text: 'Date of Birth is empty!!',
            title: 'Error'
          })
        }
        if (!this.parentdata.gender) {
          return this.$dialog.error({
            text: 'Gender value is empty!!',
            title: 'Error'
          })
        }

        this.hasClicked = true
        this.loader = true
        this.parentdata.enquiry = ''
        this.loadingComponent = this.$buefy.loading.open()
        let inputData = {
          motherTongue: this.parentdata.motherTongue,
          exposureToEnglishLanguage: this.parentdata.exposureToEnglishLanguage,
          identificationMarks: this.parentdata.identificationMarks,
          franchiseeID: this.parentdata.franchisee.id,
          academicYearID: this.studentData.academicYearID,
          studentFirstName: this.parentdata.studentFirstName,
          studentMiddleName: this.parentdata.studentMiddleName,
          studentLastName: this.parentdata.studentLastName,
          fatherName: this.studentData.fatherName,
          fatherMobile: this.studentData.fatherMobile,
          fatherEmail: this.studentData.fatherEmailID,
          fatherOccupation: this.studentData.fatherOccupation,
          motherName: this.studentData.motherName,
          motherEmailID: this.studentData.motherEmailID,
          motherMobile: this.studentData.motherMobile,
          motherOccupation: this.studentData.motherOccupation,
          address1: this.parentdata.address,
          address: this.studentData.address1,
          pincode: this.parentdata.pincode,
          country: this.studentData.countryName,
          state: this.studentData.state,
          city: this.studentData.city,
          locality: this.studentData.locality,
          dateOfBirth: this.parentdata.dateOfBirth,
          placeOfBirth: this.parentdata.placeOfBirth,
          gender: this.parentdata.gender,
          pointOfContact: this.parentdata.pointOfContact,
          guardianName: this.studentData.guardianName,
          guardianMobile: this.studentData.guardianMobile,
          guardianEmailID: this.studentData.guardianEmailID,
          fatherDesignation: this.studentData.fatherDesignation,
          fatherQualification: this.studentData.fatherQualification,
          fatherOrganisation: this.studentData.fatherOrganisation,
          fatherOfficePhoneNo: this.studentData.fatherOfficePhoneNo,
          fatherOfficeAddress: this.studentData.fatherOfficeAddress,
          motherQualification: this.studentData.motherQualification,
          motherOrganisation: this.studentData.motherOrganisation,
          motherOfficePhoneNo: this.studentData.motherOfficePhoneNo,
          motherOfficeAddress: this.studentData.motherOfficeAddress,
          motherDesignation: this.studentData.motherDesignation,
          emergencyContactDetails: this.parentdata.emergencyContactDetails,
          siblingName: this.registrationData.siblingName,
          siblingAge: this.registrationData.siblingAge,
          siblingClass: this.registrationData.siblingClass,
          siblingSchool: this.registrationData.siblingSchool,
          siblingOtherSchool: this.registrationData.siblingOtherSchool,
          referralsChildName: this.registrationData.referralsChildName,
          referralsChildAge: this.registrationData.referralsChildAge,
          referralsFatherMotherName:
            this.registrationData.referralsFatherMotherName,
          referralsFatherMotherMobileNo:
            this.registrationData.referralsFatherMotherMobileNo,
          referralsRelation: this.registrationData.referralsRelation,
          bloodGroup: this.registrationData.bloodGroup,
          anySeriousAccidentsOrIllnessOrOperarions:
            this.registrationData.anySeriousAccidentsOrIllnessOrOperarions,
          dateForSeriousAccidentsOrIllnessOrOperarions:
            this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions,
          allergiesOrAsthmaOrBreathlessness:
            this.registrationData.allergiesOrAsthmaOrBreathlessness,
          anyOtherAliment: this.registrationData.anyOtherAliment,
          specialCare: this.registrationData.specialCare,
          foodAllergies: this.registrationData.foodAllergies,
          drugAllergies: this.registrationData.drugAllergies,
          anyPhysicalChallengeOrLearningDifficulties:
            this.registrationData.anyPhysicalChallengeOrLearningDifficulties,
          prescribedMedication: this.registrationData.prescribedMedication,
          techniqueToDisciplineYourChild:
            this.registrationData.techniqueToDisciplineYourChild,
          childsUsualReactionToBeingDisciplined:
            this.registrationData.childsUsualReactionToBeingDisciplined,
          childsReactionForNewSituation:
            this.registrationData.childsReactionForNewSituation,
          isNewPeopleEasilyAcceptable:
            this.registrationData.isNewPeopleEasilyAcceptable,
          familyDoctorOrPhysicianName:
            this.registrationData.familyDoctorOrPhysicianName,
          familyDoctorOrPhysicianQualification:
            this.registrationData.familyDoctorOrPhysicianQualification,
          practicingClinicDetails:
            this.registrationData.practicingClinicDetails,
          practicingClinicOfficeTelephone:
            this.registrationData.practicingClinicOfficeTelephone,
          practicingClinicMobileNo:
            this.registrationData.practicingClinicMobileNo,
          practicingClinicEmailID:
            this.registrationData.practicingClinicEmailID,
          chikenpoxVaricellaVaccineDate:
            this.registrationData.chikenpoxVaricellaVaccineDate,
          diptheriaDTapVaccineDate:
            this.registrationData.diptheriaDTapVaccineDate,
          haemophilusInfluenzaTypeBHiBVaccineDate:
            this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate,
          hepatitisAHepAVaccineDate:
            this.registrationData.hepatitisAHepAVaccineDate,
          hepatitisBHepBVaccineDate:
            this.registrationData.hepatitisBHepBVaccineDate,
          tetanusDTapDate: this.registrationData.tetanusDTapDate,
          studentPhotoUrl: !_.isEmpty(this.registrationData.studentPhotoUrl)
            ? this.registrationData.studentPhotoUrl
            : '',
          fatherPhotoUrl: !_.isEmpty(this.registrationData.fatherPhotoUrl)
            ? this.registrationData.fatherPhotoUrl
            : '',
          motherPhotoUrl: !_.isEmpty(this.registrationData.motherPhotoUrl)
            ? this.registrationData.motherPhotoUrl
            : '',
          birthCertificateUrl: !_.isEmpty(
            this.registrationData.birthCertificateUrl
          )
            ? this.registrationData.birthCertificateUrl
            : '',
          transferCertificateUrl: !_.isEmpty(
            this.registrationData.transferCertificateUrl
          )
            ? this.registrationData.transferCertificateUrl
            : '',
          immunisationCertificateUrl: !_.isEmpty(
            this.registrationData.immunisationCertificateUrl
          )
            ? this.registrationData.immunisationCertificateUrl
            : '',
          studentAadharCardUrl: !_.isEmpty(
            this.registrationData.studentAadharCardUrl
          )
            ? this.registrationData.studentAadharCardUrl
            : '',
          fatherAadharCardUrl: !_.isEmpty(
            this.registrationData.fatherAadharCardUrl
          )
            ? this.registrationData.fatherAadharCardUrl
            : '',
          motherAadharCardUrl: !_.isEmpty(
            this.registrationData.motherAadharCardUrl
          )
            ? this.registrationData.motherAadharCardUrl
            : '',
          healthCertificateUrl: !_.isEmpty(
            this.registrationData.healthCertificateUrl
          )
            ? this.registrationData.healthCertificateUrl
            : '',
          senCertificateUrl: !_.isEmpty(
            this.registrationData.senCertificateUrl
          )
            ? this.registrationData.senCertificateUrl
            : '',
          studentPhoto: this.registrationData.studentPhoto,
          fatherPhoto: this.registrationData.fatherPhoto,
          motherPhoto: this.registrationData.motherPhoto,
          birthCertificate: this.registrationData.birthCertificate,
          transferCertificate: this.registrationData.transferCertificate,
          immunisationCertificate:
            this.registrationData.immunisationCertificate,
          studentAadharCard: this.registrationData.studentAadharCard,
          fatherAadharCard: this.registrationData.fatherAadharCard,
          motherAadharCard: this.registrationData.motherAadharCard,
          healthCertificate: this.registrationData.healthCertificate,
          senCertificate: this.registrationData.senCertificate,
          siblingEnquiryID: this.registrationData.siblingEnquiryID || null,
          registrationCode: this.registrationData.registrationCode,
          enquiryCode: this.studentData.enquiryCode,
          iAgreeCheckbox: this.registrationData.iAgreeCheckbox
        }

        if (!this.isUniformSelectionNotRequired) {
          // Saving Uniform Selection
          await http.post(
            `${constants.API_URL}/api/product/student-appreal-application`,
            {
              franchiseeID: this.parentdata.franchisee.id,
              academicYearID: this.parentdata.academicYearID,
              studentAppreals: this.parentdata.studentAppreals,
              enquiryID: this.parentdata.id,
              gender: this.parentdata.gender
            }
          )
        }

        const formData = new FormData()
        for (var key in inputData) {
          if (
            typeof inputData[key] === 'undefined' ||
            inputData[key] === null
          ) {
            inputData[key] = ''
          }
          formData.append(key, inputData[key])
        }
        formData.append('enquiryID', this.parentdata.id)
        formData.append('transportManagedByCenter', this.studentData.transportManagedByCenter)
        formData.append('transportManagedByVendor', this.studentData.transportManagedByVendor)
        formData.append('isTransport', this.studentData.isTransport)
        formData.append('transportMode', this.studentData.transportMode)

        await http.put(
          `${constants.API_URL}/api/edit-registration/${this.refID}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )

        this.dialog = true

        // this.$router.push({ name: 'OfflinePayments', params: { referenceID: this.refID } })

        /*
        this.loader = false
        this.$router.push({ name: 'thankyou' })

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Registration updated successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        }) */
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While updating registration Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
